import axios from 'axios';
import axiosInstance from 'utils/axios';

import { PaginatedResponse } from 'api/api.model';
import { apiEndpoints } from 'apiEndpoints';

import {
  CategoryAddViewModel,
  CategoryGetViewModel,
  CategoryModifyViewModel,
} from './categories.model';

// TODO filters, also probably wont be used
const getCategories = async (): Promise<PaginatedResponse<CategoryGetViewModel>> => {
  const response = await axiosInstance.get(apiEndpoints.categories.index);
  return response.data;
};

// TODO probably wont be used
const postCategories = async (addCategory: CategoryAddViewModel): Promise<void> => {
  const response = await axios.post(apiEndpoints.categories.index, addCategory);
  return response.data;
};

// TODO filters, also probably wont be used
const getCategoriesID = async (id: string): Promise<CategoryGetViewModel> => {
  const response = await axios.get(apiEndpoints.categories.index, { params: { id: id } });
  return response.data;
};

// TODO probably wont be used
const patchCategoriesID = async (
  id: string,
  toggleCategoryInData: CategoryModifyViewModel
): Promise<void> => {
  const response = await axios.get(apiEndpoints.categories.index, {
    params: { id: id, toggleCategoryInData: toggleCategoryInData },
  });
  return response.data;
};

const categories = {
  getCategories,
  postCategories,
  getCategoriesID,
  patchCategoriesID,
};

export default categories;
